export default "__VITE_ASSET__BlQAdXSU__"